import firebase from 'firebase/app'
import 'firebase/firestore'

var firebaseConfig = {
  apiKey: 'AIzaSyBUJEHPsOo2oZnA0OutDkVhHtVvI9-NpP8',
  authDomain: 'ninja-chat-39609.firebaseapp.com',
  databaseURL: 'https://ninja-chat-39609.firebaseio.com',
  projectId: 'ninja-chat-39609',
  storageBucket: 'ninja-chat-39609.appspot.com',
  messagingSenderId: '25769274973',
  appId: '1:25769274973:web:e97a765848fa843e3427b4'
}
const firebaseApp = firebase.initializeApp(firebaseConfig)

export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/firebase/init.js